import React, { useState } from 'react';
import { X } from 'lucide-react';

const RecipientInput = ({ label, recipients, onAdd, onRemove }) => {
    const [input, setInput] = useState('');
    
    const handleKeyDown = (e) => {
        if (['Enter', ',', 'Tab'].includes(e.key)) {
            e.preventDefault();
            const val = input.trim().replace(/,/g, '');
            if (val && val.includes('@')) { 
                onAdd({ email: val, name: val.split('@')[0] }); 
                setInput(''); 
            }
        } else if (e.key === 'Backspace' && !input && recipients.length > 0) {
            onRemove(recipients.length - 1);
        }
    };

    return (
        <div className="space-y-1">
            <label className="text-xs font-bold text-slate-500 uppercase tracking-wide">{label}</label>
            <div className="flex flex-wrap gap-2 p-2 bg-white border border-slate-300 rounded-lg focus-within:ring-2 focus-within:ring-blue-500 min-h-[42px]">
                {recipients.map((r, i) => (
                    <div key={i} className="flex items-center gap-1 bg-blue-50 border border-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs">
                        <span className="truncate max-w-[150px]">{r.email}</span>
                        <button onClick={() => onRemove(i)} className="hover:text-blue-900 rounded-full p-0.5"><X className="w-3 h-3" /></button>
                    </div>
                ))}
                <input 
                    type="text" 
                    className="flex-1 min-w-[120px] outline-none text-sm text-slate-700 bg-transparent" 
                    placeholder={recipients.length === 0 ? "Enter emails..." : ""} 
                    value={input} 
                    onChange={e => setInput(e.target.value)} 
                    onKeyDown={handleKeyDown} 
                />
            </div>
        </div>
    );
};

export default RecipientInput;